(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        function registerBulkPricingProgress() {
            if (window.Alpine && window.Alpine.data) {
                window.Alpine.data("bulkPricingProgress", (({totalQty: totalQty}) => ({
                    totalQty: totalQty || 0,
                    config: null,
                    steps: [],
                    progressPercent: 0,
                    message: "",
                    showPopup: false,
                    cartObserver: null,
                    init() {
                        this.loadConfig();
                        this.setupSteps();
                        this.updateTotalFromDOM();
                        this.calculateProgress();
                        this.setMessage();
                        this.handleInput = this.handleInput.bind(this);
                        document.addEventListener("input", this.handleInput);
                        document.addEventListener("change", this.handleInput);
                        window.addEventListener("bulk-pricing:quantity-changed", (event => {
                            if (event.detail && typeof event.detail.quantity !== "undefined") {
                                const newQty = parseInt(event.detail.quantity) || 0;
                                if (newQty !== this.totalQty) {
                                    this.totalQty = newQty;
                                    this.calculateProgress();
                                    this.setMessage();
                                }
                            }
                            setTimeout((() => {
                                this.updateTotalFromDOM();
                            }), 300);
                        }));
                        const cartIcon = document.getElementById("cart-icon-bubble");
                        this.cartBubbleObserver = new MutationObserver((() => {
                            this.updateTotalFromDOM();
                        }));
                        if (cartIcon) {
                            this.cartBubbleObserver.observe(cartIcon, {
                                subtree: true,
                                childList: true,
                                characterData: true
                            });
                        }
                    },
                    destroy() {
                        document.removeEventListener("input", this.handleInput);
                        document.removeEventListener("change", this.handleInput);
                        if (this.cartBubbleObserver) {
                            this.cartBubbleObserver.disconnect();
                            this.cartBubbleObserver = null;
                        }
                        if (this.cartParentObserver) {
                            this.cartParentObserver.disconnect();
                            this.cartParentObserver = null;
                        }
                    },
                    handleInput(e) {
                        const inDrawer = !!e.target.closest(".cart-drawer");
                        const inCartPage = !!(e.target.closest(".cart-items") || e.target.closest(".cart__items"));
                        if ((inDrawer || inCartPage) && e.target.matches(".quantity__input")) {
                            this.updateTotalFromDOM();
                        }
                    },
                    updateTotalFromDOM() {
                        const cartCountElement = document.querySelector("#cart-icon-bubble .custom-cart-item-count");
                        let iconQty = 0;
                        if (cartCountElement) {
                            iconQty = parseInt(cartCountElement.textContent) || 0;
                        }
                        const drawerInputs = document.querySelectorAll(".cart-drawer .quantity__input");
                        const cartInputs = document.querySelectorAll(".cart-items .quantity__input, .cart__items .quantity__input");
                        const inputs = drawerInputs.length || document.querySelector(".cart-drawer") ? drawerInputs : cartInputs;
                        let sum = 0;
                        if (inputs.length) {
                            inputs.forEach((input => {
                                sum += parseInt(input.value, 10) || 0;
                            }));
                        }
                        if (sum < iconQty && iconQty > 0) {
                            sum = iconQty;
                        }
                        if (sum !== this.totalQty) {
                            this.totalQty = sum;
                            this.calculateProgress();
                            this.setMessage();
                            window.dispatchEvent(new CustomEvent("bulk-pricing:cart-updated", {
                                detail: {
                                    totalQty: this.totalQty
                                }
                            }));
                        }
                    },
                    loadConfig() {
                        const sectionId = this.$el && this.$el.dataset ? this.$el.dataset.sectionId : null;
                        let configElement = null;
                        if (sectionId) {
                            configElement = document.querySelector(`#bulk-pricing-config[data-section-id="${sectionId}"]`);
                        }
                        if (!configElement) {
                            configElement = document.getElementById("bulk-pricing-config");
                        }
                        if (configElement) {
                            try {
                                const cfg = JSON.parse(configElement.textContent);
                                if (cfg && typeof cfg === "object") {
                                    if (cfg.discountTiersStr && (!cfg.discountTiers || cfg.discountTiers.length === 0)) {
                                        try {
                                            cfg.discountTiers = JSON.parse(cfg.discountTiersStr);
                                        } catch (err) {
                                            console.error("Failed to parse discountTiersStr:", err);
                                        }
                                    }
                                    this.config = cfg;
                                }
                            } catch (e) {
                                console.error("Failed to parse bulk pricing config:", e);
                            }
                        }
                    },
                    setupSteps() {
                        if (!this.config || !this.config.discountTiers) return;
                        this.steps = [ ...this.config.discountTiers ];
                    },
                    calculateProgress() {
                        if (!this.config || !this.config.discountTiers || this.config.discountTiers.length === 0) {
                            this.progressPercent = 0;
                            return;
                        }
                        const tiers = this.config.discountTiers;
                        const tierCount = tiers.length;
                        const segmentSize = 100 / tierCount;
                        const points = [ {
                            qty: 0,
                            percent: 0
                        } ];
                        tiers.forEach(((tier, index) => {
                            const min = Number(tier.min) || 0;
                            const max = Number(tier.max) || 0;
                            const centerPercent = index * segmentSize + segmentSize / 2;
                            points.push({
                                qty: min,
                                percent: centerPercent
                            });
                            if (max > 0) {
                                const endPercent = (index + 1) * segmentSize;
                                points.push({
                                    qty: max,
                                    percent: endPercent
                                });
                            }
                        }));
                        const lastPoint = points[points.length - 1];
                        if (lastPoint.percent < 100) {
                            const endQty = Math.ceil(lastPoint.qty * 1.5);
                            points.push({
                                qty: endQty,
                                percent: 100
                            });
                        }
                        let targetPercent = 0;
                        if (this.totalQty >= points[points.length - 1].qty) {
                            targetPercent = 100;
                        } else {
                            for (let i = 0; i < points.length - 1; i++) {
                                const p1 = points[i];
                                const p2 = points[i + 1];
                                if (this.totalQty >= p1.qty && this.totalQty <= p2.qty) {
                                    if (p1.qty === p2.qty) {
                                        targetPercent = p2.percent;
                                    } else {
                                        const ratio = (this.totalQty - p1.qty) / (p2.qty - p1.qty);
                                        targetPercent = p1.percent + ratio * (p2.percent - p1.percent);
                                    }
                                    break;
                                }
                            }
                        }
                        this.progressPercent = Math.min(Math.max(targetPercent, 0), 100);
                    },
                    setMessage() {
                        if (!this.config || !this.config.discountTiers || this.config.discountTiers.length === 0) {
                            this.message = this.config && this.config.title || "";
                            return;
                        }
                        const currentTier = this.config.discountTiers.find((tier => this.totalQty >= tier.min && (tier.max === null || tier.max === 0 || this.totalQty <= tier.max)));
                        const nextTier = this.config.discountTiers.find((tier => tier.min > this.totalQty));
                        if (nextTier) {
                            const needed = nextTier.min - this.totalQty;
                            let discountText = "";
                            if (nextTier.discountType === "percentage") {
                                const discountValue = Number(nextTier.discountValue);
                                const percentage = discountValue <= 1 ? discountValue * 100 : discountValue;
                                discountText = Math.round(percentage) + "% off";
                            } else if (nextTier.discountType === "fixed_amount") {
                                discountText = "$" + nextTier.discountValue + " off";
                            }
                            this.message = `Add ${needed} more item${needed > 1 ? "s" : ""} to get ${discountText}`;
                        } else if (currentTier) {
                            let discountText = "";
                            if (currentTier.discountType === "percentage") {
                                const discountValue = Number(currentTier.discountValue);
                                const percentage = discountValue <= 1 ? discountValue * 100 : discountValue;
                                discountText = Math.round(percentage) + "% off";
                            } else if (currentTier.discountType === "fixed_amount") {
                                discountText = "$" + currentTier.discountValue + " off";
                            }
                            this.message = `You're getting ${discountText} - maximum discount reached!`;
                        } else {
                            const firstTier = this.config.discountTiers[0];
                            if (firstTier) {
                                const needed = firstTier.min - this.totalQty;
                                let discountText = "";
                                if (firstTier.discountType === "percentage") {
                                    const discountValue = Number(firstTier.discountValue);
                                    const percentage = discountValue <= 1 ? discountValue * 100 : discountValue;
                                    discountText = Math.round(percentage) + "% off";
                                } else if (firstTier.discountType === "fixed_amount") {
                                    discountText = "$" + firstTier.discountValue + " off";
                                }
                                this.message = `Add ${needed} more item${needed > 1 ? "s" : ""} to get ${discountText}`;
                            } else {
                                this.message = this.config && this.config.title || "";
                            }
                        }
                    },
                    benefitText(step) {
                        if (!step) return "";
                        if (step.discountType === "percentage") {
                            const discountValue = Number(step.discountValue);
                            if (isNaN(discountValue)) return "";
                            const percentage = discountValue <= 1 ? discountValue * 100 : discountValue;
                            return Math.round(percentage) + "% OFF";
                        } else if (step.discountType === "fixed_amount") {
                            const discountValue = Number(step.discountValue);
                            if (isNaN(discountValue)) return "";
                            return "$" + discountValue + " OFF";
                        }
                        return step && step.label || "";
                    },
                    rangeText(step) {
                        if (!step || !step.min) return "";
                        const max = Number(step.max);
                        return !max ? `${step.min}+` : `${step.min}-${step.max}`;
                    }
                })));
            }
        }
        if (window.Alpine) {
            registerBulkPricingProgress();
        } else {
            document.addEventListener("alpine:init", registerBulkPricingProgress);
        }
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();